import { buildWidgetLoginUrl } from '../api/widget-login.js';
import type { WidgetLoginRequest, WidgetLoginResponse } from '@teo/widget-shared';
import {
  getWidgetSession,
  updateWidgetSessionThreadId,
} from '../session/widget-session.js';

/** Re-fetch login to pick up `thread_id` assigned after the first queued message. */
export async function refreshWidgetSessionThread(
  apiBase: string,
): Promise<number | null> {
  const session = getWidgetSession();
  if (!session) return null;

  const url = buildWidgetLoginUrl(apiBase, session.slug);
  const body: WidgetLoginRequest = { visitor_id: session.visitorId };

  const response = await fetch(url, {
    method: 'POST',
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) return null;

  const login = (await response.json()) as WidgetLoginResponse;
  if (login.thread_id) {
    updateWidgetSessionThreadId(login.thread_id);
    return login.thread_id;
  }

  return null;
}
